import { render, staticRenderFns } from "./ratioOut-add-or-update.vue?vue&type=template&id=9bd3c888&scoped=true"
import script from "./ratioOut-add-or-update.vue?vue&type=script&lang=js"
export * from "./ratioOut-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./ratioOut-add-or-update.vue?vue&type=style&index=0&id=9bd3c888&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bd3c888",
  null
  
)

export default component.exports